export const SERVICE_NAME = 'glomopay-investor-portal';

export const OTEL_ENABLED = import.meta.env?.VITE_OTEL_ENABLED === 'true';
